import { Component } from '@angular/core';
import { Subject, filter, takeUntil } from 'rxjs';

import { CompanyPlanTypes } from '@site-mate/sitemate-global-shared/lib';

import { TemplateFieldBaseComponent } from 'app/form-fields/common/template/template-field-base.component';
import { TeamService } from 'app/shared/service/team.service';

@Component({
  selector: 'cc-app-person',
  templateUrl: './person-template.component.html',
  styleUrls: ['./person-template.component.scss', '../../common/template/form-control.component.scss'],
})
export class PersonTemplateComponent extends TemplateFieldBaseComponent {
  private unSubscribe = new Subject<void>();
  isPaidUser: boolean;

  constructor(private readonly teamService: TeamService) {
    super();
  }

  ngOnInit(): void {
    this.teamService.currentTeam
      .pipe(
        takeUntil(this.unSubscribe),
        filter((team) => team._id),
      )
      .subscribe((team) => {
        this.isPaidUser = team.companyMetadata?.billing?.planType !== CompanyPlanTypes.FreeTrial;
      });
  }

  ngOnDestroy(): void {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }
}
